import { render, staticRenderFns } from "./RequestTickets.vue?vue&type=template&id=45fb009d&"
import script from "./RequestTickets.vue?vue&type=script&lang=ts&"
export * from "./RequestTickets.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports